module.exports = __webpack_public_path__ + "img/mark_star_3_icon.f27d04ac.png";